<po-page-list p-title="Painel de Aprovação"
  [p-breadcrumb]="breadcrumb"
  [p-disclaimer-group]="disclaimerGroup"
  [p-filter]="filterSettings"
>
  <div class="po-row">
    <po-button class="po-sm-6 po-md-3 po-lg-2"
     p-label="Consultar" 
     (p-click)="tabelaPrincipalLoad()"
    ></po-button>
    <po-button class="po-sm-6 po-md-3 po-lg-2" 
     p-label="Excel" 
     (p-click)="exportaExcel()"
     [p-disabled]="!tabelaPrincipalItens.length"
    ></po-button>
  </div>
  <div class="po-sm-12 po-md-12 po-lg-12">
    <po-table class="po-sm-12 po-md-12 po-lg-12" 
     #poTablePrincipal 
     p-container="shadow" 
     p-text-wrap="false"
     p-hide-table-search="false"
     p-hide-detail="false"
     p-hide-columns-manager="false"
     p-height="600" 
     p-striped="true" 
     [p-columns]="tabelaPrincipalColunas" 
     [p-items]="tabelaPrincipalItensFiltrado"
     (p-expanded)="loadAprovacoes($event)"
    >
    <ng-template
     p-table-row-template
     let-rowItem
     let-i="rowIndex"
     p-tooltip="Detalhes"
     [p-table-row-template-arrow-direction]="'left'"
     [p-table-row-template-show]="showDetalhes"
    >
    <po-table class="po-sm-12 po-md-12 po-lg-12"
     p-spacing="small"
     [p-striped]="true"
     [p-columns]="tabelaDetalhesColunas"
     [p-items]="tabelaPrincipalDetalhes"
     p-hide-columns-manager="false"
     [p-height]="300"
    ></po-table>
    </ng-template>
  </po-table>
  </div>
</po-page-list>

<po-modal #filtroAvancadoModal p-title="Filtro" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker class="po-md-6"
     p-label="Emissão Pedido de:" 
     name="DC7EMISSAO_DE"
     [(ngModel)]="tabelaPrincipalFiltro.dados.DC7EMISSAO_DE" 
     p-format="dd/mm/yyyy"
     [p-iso-format]="formatBasic"
    ></po-datepicker>
    <po-datepicker class="po-md-6"
     p-label="Emissão Pedido até" 
     name="DC7EMISSAO_ATE"
     [(ngModel)]="tabelaPrincipalFiltro.dados.DC7EMISSAO_ATE" 
     [p-iso-format]="formatBasic"
    ></po-datepicker>
    <po-input class="po-md-6" 
     p-label="Pedido" 
     name="CCRNUM" 
     [(ngModel)]="tabelaPrincipalFiltro.dados.CCRNUM"
     p-maxlength="6"
    ></po-input>
    <po-select 
     p-label="Status" 
     class="po-md-6" 
     name="CRSTATUS" 
     [(ngModel)]="tabelaPrincipalFiltro.dados.CCRSTATUS"
     [p-options]="[{value: '02', label: 'Pendente'},{value: '03', label: 'Aprovado'}]"
    ></po-select>
    <po-lookup class="po-md-6" 
     p-label="Centro de Custo" 
     name="CC7CC" 
     [(ngModel)]="tabelaPrincipalFiltro.dados.CC7CC"
     p-field-label="CCTTDESC01" 
     p-field-value="CCTTCUSTO" 
     [p-columns]="centroCustoColumnsFilters"
     [p-field-format]="centroCustoLookupService.getFieldFormater" 
     [p-filter-service]="centroCustoLookupService"
     [p-advanced-filters]="centroCustoLookupService.getAdvancedFilter()"
     [p-literals]="{ modalTitle: 'Centro de Custo' }" 
     p-multiple="true"
    ></po-lookup>
    <po-lookup class="po-md-6" 
     p-label="Fornecedor" 
     name="fornecedor"
     [(ngModel)]="tabelaPrincipalFiltro.dados.CFORNECEDORLOJA" 
     p-field-value="CA2CODLOJA"
     [p-columns]="fornecedorColumnsFilters" 
     [p-field-format]="fornecedorFieldFormaterFilters"
     [p-filter-service]="fornecedorLookupService" 
     [p-advanced-filters]="fornecedorAdvancedFilters"
     [p-literals]="{ modalTitle: 'Fornecedor'}"
    ></po-lookup>
    <po-select class="po-md-4"
     p-label="Registros por Consulta" 
     name="pageSize"
     [(ngModel)]="tabelaPrincipalFiltro.dados.pageSize" 
     [p-options]="[
         {value: 10, label: '10'},
         {value: 20, label: '20'},
         {value: 50, label: '50'},
         {value: 100, label: '100'},
         {value: 200, label: '200'}]"
     ></po-select>
  </form>
</po-modal>